// 配置 login
export default [{
  path: '/login',
  name: 'login',
  component: () => import('@/views/login/login-v2.vue'),
  meta: {
    // isShowNav: 1,
    isShowFoot: 1,
  }
},{
  path: '/login2',
  name: 'login',
  component: () => import('@/views/login/login.vue'),
  meta: {
    // isShowNav: 1,
    // isShowFoot: 1,
  }
}, {
  path: '/register',
  name: 'register',
  component: () => import('@/views/login/register.vue')
}, {
  path: '/forget',
  name: 'forget',
  component: () => import('@/views/login/forget.vue')
}, {
  path: '/agreement',
  name: 'agreement',
  component: () => import('@/views/others/agreementOne.vue')
}]



// WEBPACK FOOTER //
// ./src/router/modules/login.js